import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-sidenav-component',
  templateUrl: './sidenav-component.component.html',
  styleUrls: ['./sidenav-component.component.css']
})
export class SidenavComponentComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) { }


  ngOnInit() {
    debugger;
    
  }
pageload(){
  debugger;
 // this.router.navigate(['/homepages/faq']);
  //this.topFunction();
  //return true;
}

topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}
}



// WEBPACK FOOTER //
// ./src/app/home/sidenav-component/sidenav-component.component.ts